import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Kicker, Divider } from './ui/Typography';
export function HeroSection() {
  return <Section hasOrb={true} className="pt-32 pb-20 sm:pt-40 lg:pt-48" data-id="element-86">
      <div className="max-w-4xl" data-id="element-87">
        {/* 2026 EDITION badge */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-block bg-brand text-black font-mono font-bold text-xs px-3 py-1.5 rounded-[6px] uppercase tracking-[0.18em] mb-8" data-id="element-88">
          2026 EDITION
        </motion.div>

        <Kicker data-id="element-89">FOR EVERYDAY PEOPLE</Kicker>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="font-archivo uppercase leading-[0.92] tracking-tighter text-[clamp(40px,9vw,96px)]" data-id="element-90">
          THE AI <span className="text-brand" data-id="element-91">INCOME</span> BLUEPRINT
        </motion.h1>

        <Divider data-id="element-92" />

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-ink-dim text-xl sm:text-2xl max-w-2xl mb-12 leading-relaxed" data-id="element-93">
          How everyday people use ChatGPT and Claude to build real income. 7
          proven paths. 30 day plan. 100 prompts.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="grid grid-cols-3 gap-4 sm:gap-6 mb-12 max-w-2xl" data-id="element-94">
          {[{
          num: '7',
          label: 'INCOME PATHS'
        }, {
          num: '30',
          label: 'DAY PLAN'
        }, {
          num: '100',
          label: 'PROMPTS'
        }].map((stat, i) => <div key={i} className="flex items-center gap-3" data-id="element-95">
              <span className="font-archivo text-brand text-3xl sm:text-4xl lg:text-5xl" data-id="element-96">
                {stat.num}
              </span>
              <span className="font-mono text-ink-dim text-xs sm:text-sm uppercase tracking-widest leading-tight" data-id="element-97">
                / {stat.label}
              </span>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-col items-start gap-4" data-id="element-98">
          <Button testId="hero-cta" className="w-full sm:w-auto" scrollTo="offer" data-id="element-99">
            GET THE BLUEPRINT · $17
          </Button>
          <p className="text-ink-dim text-sm" data-id="element-100">
            <span className="line-through opacity-50 mr-2" data-id="element-101">$34</span>
            Launch price, limited time.
          </p>
        </motion.div>
      </div>
    </Section>;
}